// extracted by mini-css-extract-plugin
export var active = "Services-module--active--512da";
export var block = "Services-module--block--9d00b";
export var button = "Services-module--button--fd40f";
export var decor = "Services-module--decor--1d446";
export var greenBlock = "Services-module--greenBlock--db759";
export var image = "Services-module--image--92ef4";
export var imageContainer = "Services-module--imageContainer--f2db0";
export var item = "Services-module--item--8e514";
export var lineAbove = "Services-module--lineAbove--2bfde";
export var mobile = "Services-module--mobile--48775";
export var relativeWrapper = "Services-module--relativeWrapper--582b8";
export var serviceCarousel = "Services-module--serviceCarousel--36c53";
export var serviceDetails = "Services-module--serviceDetails--282b0";
export var serviceList = "Services-module--serviceList--c8802";
export var services = "Services-module--services--cae49";
export var textBlock = "Services-module--textBlock--6020f";
export var wrapper = "Services-module--wrapper--f5081";